import axios from "axios";
import "./request_interceptor";

//const end_point1 = "http://192.168.30.225:88/api/services/";
//const end_point1 = "https://preprodb.portailachats.ma/api/services/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/services/";



////////////////////////////////////////////////////
//// logins
////////////////////////////////////////////////////

export const login_request = async (data) => {
  return await axios.post(end_point1 + "login", data);
};

export const sso_login = async (loginResponse) => {
  return await axios.post(end_point1 + "sso-login", {
        microsoft_token: loginResponse.accessToken
    });
};

export const logout_request = async () => {
  return await axios.post(end_point1 + "logout");
};

export const get_email_by_idUser = async (id_user) => {
  return await axios.get(end_point1 + "get_email_by_idUser/" + id_user);
};

////////////////////////////////////////////////////
//// company
////////////////////////////////////////////////////

export const get_company_logo = async () => {
  return await axios.get(end_point1 + "get_company_logo");
};


export const get_directions = async () => {
  return await axios.get(end_point1 + "get_directions");
};

////////////////////////////////////////////////////
//// ServiceIdentity
////////////////////////////////////////////////////

export const get_serviceIdentity_profileImg = async (id_service) => {
  return await axios({
    url: end_point1 + "get_serviceIdentity_profileImg/" + id_service,
    method: "POST",
    responseType: "blob",
    headers: {
      "Content-Type": "image/*",
    },
  });
};

export const update_serviceIdentity_infos = async (data) => {
  return await axios.post(end_point1 + "update_serviceIdentity_infos", data);
};

export const update_serviceIdentity_profileImg = async (data) => {
  return await axios.post(
    end_point1 + "update_serviceIdentity_profileImg",
    data
  );
};

export const get_some_purchaseServiceInfos_by_idSubmission = async (
  id_submission
) => {
  return await axios.get(
    end_point1 +
      "get_some_purchaseServiceInfos_by_idSubmission/" +
      id_submission
  );
};

export const get_contracts_types = async () => {
  return await axios.get(end_point1 + "get_contracts_types");
};

////////////////////////////////////////////////////
//// bills
////////////////////////////////////////////////////

export const notify_finance_service = async(data)  => {
    return await axios.post(end_point1+'notify_finance_service',data);
}

export const notify_purchase_services_with_bills = async(data)  => {
    return await axios.post(end_point1+'notify_purchase_services_with_bills',data);
}


export const download_bills_docs = async(data) => {
    return await axios({
        url: end_point1+'download_bills_docs',
        method:'POST',
          data:data,
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/*',
          },
      });
}

export const services_bills_accord_withEmail = async (data) => {
  return await axios.post(end_point1 + "services_bills_accord_withEmail", data);
};

export const services_requests_orders_bills_accord_withEmail = async (data) => {
  return await axios.post(
    end_point1 + "services_requests_orders_bills_accord_withEmail",
    data
  );
};


export const get_all_services = async () => {
  return await axios.get(end_point1 + "get_all_services");
};

export const get_allPurchaseServices = async () => {
  return await axios.get(end_point1 + "get_allPurchaseServices");
};

export const get_allFinancesService = async () => {
  return await axios.get(end_point1 + "get_allFinancesService");
};

export const get_user_emails_sent = async (id_login, searchFilete, page) => {
  return await axios.get(
    end_point1 +
      "get_user_emails_sent/" +
      id_login +
      "/" +
      searchFilete +
      "?page=" +
      page
  );
};

export const search_users_byname_or_email_forServ = async () => {
  return await axios.get(end_point1 + "search_users_byname_or_email_forServ");
};

export const send_email_from_emails_menu = async (data) => {
  return await axios.post(end_point1 + "send_email_from_emails_menu", data);
};

////////////////////////////////////////////////////
//// applicant_requests
////////////////////////////////////////////////////

export const requester_change_order_state = async(data) => {
    return await axios.post(end_point1+'requester_change_order_state',data);
}

export const validate_purchase_request_wf_process = async(data) => {
    return await axios.post(end_point1+'validate_purchase_request_wf_process',data);
}


////////////////////////////////////////////////////
//// suppliers
////////////////////////////////////////////////////

export const get_suppliers_by_category = async (filterCategorie) => {
  return await axios.get(
    end_point1 + "get_suppliers_by_category/" + filterCategorie
  );
};

export const get_suppliers = async () => {
  return await axios.get(end_point1 + "get_suppliers");
};

////////////////////////////////////////////////////
//// products
////////////////////////////////////////////////////

export const get_categories_forAll_services = async () => {
  return await axios.get(end_point1 + "get_categories_forAll_services");
};

export const get_requester_purchase_requests = async(params) => {
    return await axios.get(end_point1+'get_requester_purchase_requests',{
      params:params
    });
}

export const get_purchase_requests_to_be_validated = async(data,searchFilter,searchValue,page) => {
    return await axios.post(end_point1+'get_purchase_requests_to_be_validated/'+searchFilter+'/'+searchValue+"?page="+page,data);
}

export const get_products = async (filterCategorie,filterSupplier,searchValue,page) => {
  return await axios.get(
    end_point1 +
      "get_products/" +
      filterCategorie +
      "/" +
      filterSupplier +
      "/" +
      searchValue +
      "?page=" +
      page
  );
};

export const get_all_products = async (params) => {
  return await axios.get(end_point1 + 'get_all_products', {
    params:params
  } )
};

export const get_products_byCode = async (product_code) => {
  return await axios.post(end_point1 + "get_products_byCode", product_code);
};

export const get_order_productsInfos = async (product_code) => {
  return await axios.post(end_point1 + "get_order_productsInfos", product_code);
};

export const get_supplier_products = async (
  id_supplier,
  filterCategorie,
  searchValue,
  page
) => {
  return await axios.get(
    end_point1 +
      "get_supplier_products/" +
      id_supplier +
      "/" +
      filterCategorie +
      "/" +
      searchValue +
      "?page=" +
      page
  );
};

export const add_product_by_service = async (data) => {
  return await axios.post(end_point1 + "add_product_by_service", data);
};

export const update_product_by_service = async (data) => {
  return await axios.post(end_point1 + "update_product_by_service", data);
};

export const archive_product_by_service= async (data) => {
  return await axios.post(end_point1 + "archive_product_by_service", data);
};

export const import_products_catalogues_by_service = async (data) => {
  return await axios.post(end_point1 + "import_products_catalogues_by_service", data);
};

export const add_purchase_request = async (request_infos) => {
  return await axios.post(end_point1 + "add_purchase_request", request_infos);
};

export const edit_purchase_request = async (request_infos) => {
  return await axios.post(end_point1 + "edit_purchase_request", request_infos);
};

export const add_off_catalogue_purchase_request = async (request_infos) => {
  return await axios.post(
    end_point1 + "add_off_catalogue_purchase_request",
    request_infos
  );
};

export const add_SelectedSupplier_to_purchase_request = async (
  request_infos
) => {
  return await axios.post(
    end_point1 + "add_SelectedSupplier_to_purchase_request",
    request_infos
  );
};

export const download_order_file = async(data) => {
    return await axios({
        url: end_point1+'download_order_file',
        method:'POST',
        data:data,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/*',
        },
      });
}
export const download_delivery_file = async(data) => {
    return await axios({
        url: end_point1+'download_delivery_file',
        method:'POST',
        data:data,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/*',
        },
      });
}

export const accord_request_orders_by_requester = async (data) => {
  return await axios.post(
    end_point1 + "accord_request_orders_by_requester",
    data
  );
};

export const accord_order_file_by_supplier = async (data) => {
  return await axios.post(end_point1 + "accord_order_file_by_supplier", data);
};

export const download_orderRequest_quote = async (data) => {
  return await axios({
    url: end_point1 + "download_orderRequest_quote",
    method: "POST",
    data: data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/*",
    },
  });
};

////////////////////////////////////////////////////
//// docs
////////////////////////////////////////////////////

export const get_ao_docs = async (wf, id) => {
  return await axios.get(end_point1 + "get_wf_docs/" + wf + "/" + id);
};

export const import_doc = async (data) => {
  return await axios.post(end_point1 + "import_doc", data);
};

export const download_doc = async (data) => {
  return await axios({
    url: end_point1 + "download_doc",
    method: "POST",
    data: data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/*",
    },
  });
};

export const validate_doc = async (data) => {
  return await axios.post(end_point1 + "validate_doc", data);
};

export const download_file_by_path = async(data) => {
    return await axios({
        url: end_point1+'download_file_by_path',
        method:'POST',
        data:data,
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/*',
        },
      });
}


/////////////////////////////////////////////////////////////////////////
///////////// DA_wf_validation
////////////////////////////////////////////////////////////////////////////

export const check_weither_ispossible_to_proceed = async(data) => {
    return await axios.post(end_point1+"check_weither_ispossible_to_proceed",data);
}

export const validate_request_order = async(data) => {
    return await axios.post(end_point1+"validate_request_order",data);
}

export const resend_request_order_validation_email = async(data) => {
    return await axios.post(end_point1+"resend_request_order_validation_email",data);
}

/////////////////////////////////////////////////////////////////////////
///////////// Currencies
////////////////////////////////////////////////////////////////////////////

export const get_available_currencies = async() => {
  return await axios.get(end_point1+"get_available_currencies");
}


/////////////////////////////////////////////////////////////////////////
///////////// Catalogue to download
////////////////////////////////////////////////////////////////////////////

export const upload_catalogues_document = async(data) => {
    return await axios.post(end_point1+"upload_catalogues_document",data);
}

export const get_catalogues_documents = async() => {
  return await axios.get(end_point1+"get_catalogues_documents");
}

export const downloadCatalogue = async (filename) => {
  return await axios.get(end_point1 + "downloadCatalogue/" + encodeURIComponent(filename), {
    responseType: "blob",
  });
};

export const delete_catalogues_document = async(filename) => {
  return await axios.delete(end_point1+"delete_catalogues_document/"+filename);
}